interface SectionTitleProps {
  label: string;
  title: string;
}

const SectionTitle = ({ label, title }: SectionTitleProps) => (
  <div className="text-center">
    <p className="section-title-label">{label}</p>
    <h2 className="section-title mt-3">{title}</h2>
    <div className="accent-bars justify-center mt-3">
      <div className="accent-bar-long" />
      <div className="accent-bar-short" />
    </div>
  </div>
);

export default SectionTitle;
